import { render, staticRenderFns } from "./iGiveYou.vue?vue&type=template&id=01d4be35&scoped=true"
import script from "./iGiveYou.vue?vue&type=script&lang=js"
export * from "./iGiveYou.vue?vue&type=script&lang=js"
import style0 from "./iGiveYou.vue?vue&type=style&index=0&id=01d4be35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4be35",
  null
  
)

export default component.exports